/*
 * NÚT "SAO CHÉP" MÃ VOUCHER — eGURU 29/09/2026 (góp ý anh Thắng 10:30: khối Voucher của bạn không có nút sao chép mã).
 * Dùng chung cho sections/bloy-uu-dai.liquid (Tích điểm) và snippets/gt-dong-voucher.liquid (Giới thiệu bạn bè).
 *   <button type="button" data-chep-ma="MÃ" data-chu-da-chep="Đã chép" aria-label="Sao chép MÃ">Sao chép</button>
 * Bắt sự kiện ở document nên nút nằm trong <details> "Xem thêm" (mở sau) vẫn chạy; nạp nhiều lần chỉ gắn một lần.
 * Chép bằng navigator.clipboard.writeText; không có (http, trình duyệt cũ, bị chặn) thì dùng input ẩn + execCommand('copy').
 * Cả hai đều hỏng thì bôi đen mã để khách tự chép. Chữ nút đổi thành "Đã chép" khoảng 2 giây rồi trả lại.
 */
(function () {
  if (window.__egChepMaVoucher) return;
  window.__egChepMaVoucher = true;

  function chepDuPhong(ma) {
    var o = document.createElement('input');
    o.type = 'text';
    o.value = ma;
    o.setAttribute('aria-hidden', 'true');
    o.setAttribute('tabindex', '-1');
    // font 16px để Safari iOS không phóng to trang khi chọn chữ
    o.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px;';
    document.body.appendChild(o);
    var ok = false;
    try {
      o.focus();
      o.select();
      o.setSelectionRange(0, ma.length);
      ok = document.execCommand('copy');
    } catch (e) { ok = false; }
    document.body.removeChild(o);
    return ok;
  }

  function boiDenMa(nut) {
    var dong = nut.closest('.gt-vc__dong');
    var o = dong && dong.querySelector('.gt-vc__ma');
    if (!o || !window.getSelection) return;
    try {
      var r = document.createRange();
      r.selectNodeContents(o);
      var s = window.getSelection();
      s.removeAllRanges();
      s.addRange(r);
    } catch (e) { /* bỏ qua */ }
  }

  function daChep(nut) {
    if (!nut.hasAttribute('data-chu-goc')) {
      nut.setAttribute('data-chu-goc', nut.textContent);
      nut.setAttribute('data-nhan-goc', nut.getAttribute('aria-label') || '');
    }
    var chu = nut.getAttribute('data-chu-da-chep') || 'OK';
    nut.textContent = chu;
    nut.setAttribute('aria-label', chu + ' ' + nut.getAttribute('data-chep-ma'));
    nut.classList.add('is-da-chep');
    clearTimeout(nut.__hen);
    nut.__hen = setTimeout(function () {
      nut.textContent = nut.getAttribute('data-chu-goc');
      var nhan = nut.getAttribute('data-nhan-goc');
      if (nhan) nut.setAttribute('aria-label', nhan);
      nut.classList.remove('is-da-chep');
    }, 2000);
  }

  document.addEventListener('click', function (e) {
    var nut = e.target && e.target.closest ? e.target.closest('[data-chep-ma]') : null;
    if (!nut) return;
    e.preventDefault();
    var ma = (nut.getAttribute('data-chep-ma') || '').trim();
    if (!ma) return;
    var duPhong = function () {
      if (chepDuPhong(ma)) daChep(nut);
      else boiDenMa(nut);
      try { nut.focus(); } catch (x) { /* bỏ qua */ }
    };
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      navigator.clipboard.writeText(ma).then(function () { daChep(nut); }, duPhong);
    } else {
      duPhong();
    }
  });
})();
